export const services = [
  {
    id: 'ev-temizligi',
    title: 'Ev Temizliği',
    icon: 'Home',
    shortDesc: 'Hijyen odaklı, detaylı, profesyonel hizmet.',
    image: 'https://images.unsplash.com/photo-1686178827149-6d55c72d81df',
    fullDesc: 'Evinizin her köşesini hijyen standartlarında temizliyoruz. Profesyonel ekibimiz ve modern ekipmanlarımızla yaşam alanınızı tertemiz hale getiriyoruz.',
    features: [
      'Hijyenik temizlik protokolü',
      'Detaylı oda temizliği',
      'Mutfak ve banyo dezenfeksiyonu',
      'Yer ve yüzey cilası',
      'Pencere temizliği dahil'
    ]
  },
  {
    id: 'ofis-temizligi',
    title: 'Ofis Temizliği',
    icon: 'Building2',
    shortDesc: 'Prestijli çalışma alanları için sürekli temizlik desteği.',
    image: 'https://images.unsplash.com/photo-1627905646269-7f034dcc5738',
    fullDesc: 'Ofislerinizde çalışan verimliliğini artıran temiz ve hijyenik ortamlar yaratıyoruz. Düzenli bakım programları ile işyeriniz her zaman tertemiz.',
    features: [
      'Günlük/haftalık temizlik programı',
      'Masa ve ortak alan temizliği',
      'Toplantı odası bakımı',
      'Mutfak ve WC dezenfeksiyonu',
      'Cam ve zemin parlatma'
    ]
  },
  {
    id: 'insaat-sonrasi',
    title: 'İnşaat Sonrası Temizlik',
    icon: 'HardHat',
    shortDesc: 'Tozdan iz kalmayacak şekilde uzman ekiplerle detaylı temizlik.',
    image: 'https://images.unsplash.com/photo-1759694920759-6c5537e501e6',
    fullDesc: 'Yeni binanız veya tadilat sonrası mekanınızı yaşanabilir hale getiriyoruz. İnşaat tozu ve kalıntılarından tamamen arındırıyoruz.',
    features: [
      'İnşaat tozu ve kalıntı temizliği',
      'Boya lekeleri ve yapıştırıcı temizliği',
      'Pencere ve çerçeve detay temizliği',
      'Zemin cilalama',
      'Teslim öncesi final kontrol'
    ]
  },
  {
    id: 'cam-temizligi',
    title: 'Cam Temizliği',
    icon: 'Sparkles',
    shortDesc: 'Yüksek alanlar dahil, iz bırakmayan profesyonel cam bakımı.',
    image: 'https://images.unsplash.com/photo-1482449609509-eae2a7ea42b7',
    fullDesc: 'Yüksek binalarda bile güvenli ekipman ve uzman personelimizle cam yüzeylerinizi kristal berraklığında temizliyoruz.',
    features: [
      'Yüksek bina cam temizliği',
      'İç ve dış cam yüzey temizliği',
      'Çerçeve ve pervaz temizliği',
      'İz bırakmayan özel ürünler',
      'Güvenlik sertifikalı ekip'
    ]
  }
];

export const whyChooseUs = [
  {
    title: 'Dijital İş Takibi',
    description: 'Hizmet süreci boyunca online bildirim sistemi ile şeffaf takip.',
    icon: 'Smartphone'
  },
  {
    title: 'Kalite Kontrol Checklist',
    description: 'Standartlaştırılmış temizlik protokolleri ve kontrol listeleri.',
    icon: 'ClipboardCheck'
  },
  {
    title: 'Profesyonel Ekip',
    description: 'Eğitimli, deneyimli ve sertifikalı temizlik uzmanları.',
    icon: 'Users'
  },
  {
    title: 'Şeffaf Fiyatlandırma',
    description: 'Net fiyat politikası, gizli maliyet yok.',
    icon: 'DollarSign'
  },
  {
    title: 'Zamanında Hizmet Garantisi',
    description: 'Belirlenen tarih ve saatte ekibimiz sizinle.',
    icon: 'Clock'
  }
];

export const testimonials = [
  {
    name: 'Ayşe Yılmaz',
    role: 'Ev Sahibi',
    text: 'Gerçekten kurumsal bir hizmet. Dijital takip sistemi mükemmel. Evim tertemiz oldu!',
    rating: 5
  },
  {
    name: 'Mehmet Kaya',
    role: 'Ofis Müdürü',
    text: 'Temizlik ekibi dakik, hızlı ve çok profesyonel. Ofisimiz her zaman pırıl pırıl.',
    rating: 5
  },
  {
    name: 'Zeynep Demir',
    role: 'İnşaat Müteahhiti',
    text: 'İnşaat sonrası temizlik için harika bir ekip. Tozdan eser kalmadı, teslim zamanında yapıldı.',
    rating: 5
  }
];

export const contactInfo = {
  phone: '0554 136 29 25',
  email: 'info@cdclean.com',
  address: 'İstanbul / Türkiye',
  whatsapp: '905541362925',
  instagram: 'cdcleantemizlik'
};
